export const environment = {
  production: true,
  calculatorApiUrl: "https://api-calculator.k8dev.myafsa.com",
  paymentGwEndpoint: "https://payment.k8dev.myafsa.com/"
};
